import { Loader } from '@googlemaps/js-api-loader'
import { MarkerClusterer } from '@googlemaps/markerclusterer'
import { ajaxFilter } from './ajaxFilter'

export const maintenanceMap = () => {

  let el = document.querySelector('[data-map="maintenance"]')

  if (!el) {
    return
  }

  const loader = new Loader({
    apiKey: 'AIzaSyDIH9zeBSMXJguMnIn5Gjh8PxPOdCrZzs0',
    version: 'weekly',
    libraries: ['places']
  })

  loader.loadCallback(e => {
    if (e) {
      console.log(e)
    } else {

      let incidents = JSON.parse(el.getAttribute('data-incidents'))

      const mapStyles = [
        {
          featureType: 'poi',
          stylers: [
            { visibility: 'off' }
          ]
        }
      ]

      const map = new google.maps.Map(el, {
        center: new google.maps.LatLng(51.986258, -1.520262),
        zoom: 7.5,
        disableDefaultUI: true,
        zoomControl: true,
        styles: mapStyles
        // gestureHandling: 'cooperative'
      })

      const geocoder = new google.maps.Geocoder()

      let currentIncidentIcon = {
        url: themeUri + '/assets/images/markers/current-incident.svg',
        labelOrigin: new google.maps.Point(15, -10),
      }

      let degradationOfServiceIcon = {
        url: themeUri + '/assets/images/markers/degradation-of-service.svg',
        labelOrigin: new google.maps.Point(15, -10),
      }

      let emergencyWorkIcon = {
        url: themeUri + '/assets/images/markers/emergency-work.svg',
        labelOrigin: new google.maps.Point(15, -10),
      }

      let fullWorkIcon = {
        url: themeUri + '/assets/images/markers/full-work.svg',
        labelOrigin: new google.maps.Point(15, -10),
      }

      let markers = []
      let postcodes = []

      Object.keys(incidents).forEach(function (i, key) {

        const lat = parseFloat(incidents[i].latitude)
        const lng = parseFloat(incidents[i].longitude)

        markers.push(new google.maps.Marker({
          position: { lat, lng },
          url: incidents[i].ref,
          icon: currentIncidentIcon
        }))

        if (incidents[i].postcode) {
          postcodes.push(incidents[i].postcode)
        }

        markers[key].setMap(map)

        google.maps.event.addListener(markers[key], 'click', function () {
          // window.location.href =  markers[key].url;
          ajaxFilter(markers[key].url)
        })

      })

      const markerCluster = new MarkerClusterer({ map, markers })

      //https://andrewwburns.com/2018/04/10/uk-postcode-validation-regex/
      function valid_postcode (postcode) {
        if (postcode.length > 6) {
          let regex = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i
          return regex.test(postcode.toUpperCase())
        }
        return false
      }

      function format_postcode (postcode) {
        // Add a space if there is more than 4 characters
        if (postcode.length >= 3) {
          let parts = postcode.match(/^([a-zA-Z]{1,2}\d{1,2}[a-zA-Z]?)\s*(\d[a-zA-Z]{2})$/)
          if (parts) {
            parts.shift()
            postcode = parts.join(' ')
          }
        }
        postcode = postcode.toUpperCase()
        return postcode
      }

      const notice = document.querySelector('.postcode-notice')
      notice.innerHTML = ''

      document.addEventListener('submit', function (event) {
        if (event.target.matches('.api-search__map form')) {

          event.preventDefault()

          const formData = new FormData(event.target)
          const postcode = formData.get('postcode')
          const input = document.querySelector('.api-search__map form input');

          if (valid_postcode(postcode) || postcode.length <= 4) {

            const cleanPostcode = format_postcode(postcode)

            const hasEvents = postcodes.some(postcode => postcode.match(cleanPostcode))

            input.value = cleanPostcode;

            geocoder
              .geocode({ address: cleanPostcode.split(' ')[0], region: 'GB' })
              .then((result) => {
                const { results } = result

                map.fitBounds(results[0].geometry.bounds)

                google.maps.event.addListenerOnce(map, 'idle', function () {
                  if (!hasEvents) {
                    notice.innerHTML = ''
                    // notice.innerHTML = `<p>No planned maintenance was found for <strong>${cleanPostcode}</strong></p>`;
                  } else {
                    notice.innerHTML = ''
                  }
                })

              })
              .catch((e) => {
                console.log(e)
                notice.innerHTML = `<p>Sorry, there was an error checking <strong>${cleanPostcode}</strong>. Please try another search.</p>`
              })

          } else {
            notice.innerHTML = '<p>Please enter a valid postcode</p>'
          }

        }

      })

    }
  })

}
